/**
 * The composer's "/" (skills) and "@" (add context) triggers open a menu and
 * then keep filtering it from whatever the user types after the trigger
 * character. This resolves the composer text into that live query, or into one
 * of the two ways a mention ends.
 */

export type MentionResolution =
  /** Text follows the trigger: filter the menu by it. */
  | { outcome: "search"; query: string }
  /**
   * Whitespace directly follows the trigger, so this was prose all along —
   * "half / half", "ping me @ 5". The menu should get out of the way and leave
   * the characters as plain text. Whitespace *after* a query still searches, so
   * multi-word names ("Deep Research") stay findable.
   */
  | { outcome: "prose" }
  /** The trigger character itself is gone (deleted, or replaced by a chip). */
  | { outcome: "triggerGone" };

export function resolveMentionQuery(
  textContent: string,
  triggerPos: number,
): MentionResolution {
  const trigger = textContent[triggerPos];
  if (trigger !== "@" && trigger !== "/") return { outcome: "triggerGone" };

  const textAfterTrigger = textContent.slice(triggerPos + 1);
  if (/^\s/.test(textAfterTrigger)) return { outcome: "prose" };

  const wordEnd = textAfterTrigger.search(/\s/);
  return {
    outcome: "search",
    query:
      wordEnd === -1 ? textAfterTrigger : textAfterTrigger.slice(0, wordEnd),
  };
}
